import type { ReactElement } from 'react';
import type { CalendarDaySummary } from '../../api/calendarTypes.js';
import { formatNumber } from './calendarUtils.js';

export interface DayMacrosLineProps {
  summary: CalendarDaySummary;
}

export function DayMacrosLine({ summary }: DayMacrosLineProps): ReactElement {
  return (
    <p
      className="text-sm"
      style={{ color: 'var(--text-muted)' }}
      data-testid="calendar-macros"
    >
      Daily Macros: {formatNumber(summary.kcal)} kcal • P:{formatNumber(summary.protein_g)}g • C:
      {formatNumber(summary.carbs_g)}g • F:{formatNumber(summary.fat_g)}g
    </p>
  );
}
